import { render } from "./TaskTimer.vue?vue&type=template&id=1ecd5dc6&scoped=true"
import script from "./TaskTimer.vue?vue&type=script&lang=js"
export * from "./TaskTimer.vue?vue&type=script&lang=js"

import "./TaskTimer.vue?vue&type=style&index=0&id=1ecd5dc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecd5dc6"]])

export default __exports__